import React, { useEffect, useState } from 'react';
import StatusBar from './StatusBar';
import { Popover, Whisper, Dropdown } from 'rsuite';
import { laptop, laptopLink, payment, paymentLink, user, userLink } from 'whealth-core-web/assets/images';
import { dateFormat, timeFormat, titlizeString } from '../Helper';
import { Link } from 'react-router-dom';
import useApiManager from 'networking/ApiManager';
import { setIsPushedToOpd } from 'redux/Slices';
import { useDispatch } from 'react-redux';

function DoctorSchedulTile(props) {
  const [isLoading, setIsLoading] = useState(false);
  const ApiClient = useApiManager();
  const dispatch = useDispatch();

  const {
    className,
    appointmentDetail,
    handleAppointmentEdit,
    setOpen,
    setCancelModal,
    height,
    isBabyMd,
    setCreatedAppointment,
    userData,
    setStatusItem,
    handleRecordPayment,
  } = props;

  // Function to mask phone number for doctor role - show first 2 and last 3 digits
  const maskPhoneNumber = (phone) => {
    if (userData?.role === 'doctor' || userData?.role === 'doctor_pms') {
      if (!phone) return '';
      const phoneStr = phone.toString();
      if (phoneStr.length < 5) return phoneStr;

      const firstTwo = phoneStr.substring(0, 2);
      const lastThree = phoneStr.substring(phoneStr.length - 3);
      const maskedMiddle = '*'.repeat(phoneStr.length - 5);

      return `${firstTwo}${maskedMiddle}${lastThree}`;
    }

    return phone;
  };

  const renderStatus = () => {
    if (appointmentDetail?.consultation_status == 'overdue') {
      return <StatusBar className='overdue' icon='schedule' status='Overdue' />;
    } else if (appointmentDetail?.consultation_status == 'no_show') {
      return <StatusBar className='noshow' icon='cancel' status='No Show' />;
    } else if (appointmentDetail?.consultation_status == 'arrived') {
      return <StatusBar className='arrived' icon='check_circle' status='Arrived' />;
    } else if (appointmentDetail?.consultation_status == 'canceled') {
      return <StatusBar className='overdue' icon='cancel' status='Canceled' />;
    } else if (appointmentDetail?.consultation_status == 'show') {
      return <StatusBar className='visited' icon='check_circle' status='Visited' />;
    } else if (appointmentDetail?.patient_attendance_status == 'pushed_to_opd') {
      return <StatusBar className='pushed_to_opd' icon='check_circle' status='Pushed To OPD' />;
    } else if (appointmentDetail?.patient_attendance_status == 'Transit') {
      return <StatusBar className='Transit' icon='check_circle' status='In Transit' />;
    } 
    else {
      return <StatusBar className='scheduled' icon='check_circle' status='Scheduled' />;
    }
  };

  const newPAF = (id,consultation_id,doctor_id,location_id) => {
    window.open(`/patient/${id}/paf/new?consultation_id=${consultation_id}&doctor_id=${doctor_id}&location_id=${location_id}`, '_blank');
  };

  const updatePAF = (id,consultation_id,doctor_id,location_id,paf_id) => {
    window.open(`/patient/${id}/paf/${paf_id}?view=1&consultation_id=${consultation_id}&doctor_id=${doctor_id}&location_id=${location_id}`, '_blank');
  };

  console.log('userData: ', userData);

  const status = [
    { title: 'Arrived', id: 'show' },
    { title: 'No Show', id: 'no_show' },
    (appointmentDetail.consultation_status == 'no_show' ||
      appointmentDetail.consultation_status == null ||
      appointmentDetail.consultation_status == 'overdue') && {
      title: 'canceled',
      id: 'canceled',
    },
  ];

  const calculateAgeInMonths = (dob) => {
    const currentDate = new Date();
    const birthDate = new Date(dob);
    const months = (currentDate?.getFullYear() - birthDate?.getFullYear()) * 12 + (currentDate?.getMonth() - birthDate?.getMonth());
    return months;
  };
  const ageInMonths = calculateAgeInMonths(appointmentDetail?.user?.date_of_birth);

  const canEditOrCancel = () => {
    if (
      appointmentDetail?.service?.title === 'procedure' ||
      appointmentDetail?.service?.title === 'followup' ||
      appointmentDetail?.service?.title === 'break' ||
      appointmentDetail?.service?.title == 'crp'
    ) {
      return (
        userData?.role !== 'ee' &&
        userData?.role !== 'ee_manager' &&
        (userData?.role === 'admin' ||
          userData?.role === 'super_admin' || // Admin can always edit/cancel
          appointmentDetail?.admin?.id === userData?.id || // The creator can edit/cancel
          (userData?.role === 'health_coach_lead' &&
            (appointmentDetail?.admin?.role === 'health_coach' ||
              appointmentDetail?.admin?.role === 'revenue_manager' ||
              appointmentDetail?.admin?.role === 'admin' ||
              appointmentDetail?.admin?.role === 'super_admin' ||
              appointmentDetail?.admin?.id === userData?.id)) ||
            (userData?.role === 'doctor' || userData?.department?.id == 2) ||
          ((userData?.role === 'health_coach' || userData?.role === 'revenue_manager') &&
            (appointmentDetail?.admin?.role === 'admin' || appointmentDetail?.admin?.role === 'super_admin')))
      );
    }

    switch (userData?.role) {
      case 'health_coach_lead':
        return (
          appointmentDetail?.admin?.role === 'admin' ||
          appointmentDetail?.admin?.role === 'super_admin' ||
          appointmentDetail?.admin?.role === 'health_coach' ||
          appointmentDetail?.admin?.role === 'revenue_manager' ||
          appointmentDetail?.admin?.id === userData?.id
        );

      case 'health_coach':
      case 'revenue_manager':
        return appointmentDetail?.admin?.role === 'admin' || appointmentDetail?.admin?.role === 'super_admin' || appointmentDetail?.admin?.id === userData?.id;

      case 'ee_manager':
        return appointmentDetail?.admin?.role === 'ee' || appointmentDetail?.admin?.id === userData?.id;

      case 'ee':
        return appointmentDetail?.admin?.id === userData?.id;

      case 'admin':
      case 'super_admin':
        return true;
      case 'doctor':
        return true;
      default:
        return false;
    }
  };

  const canRecordOrMarkArrived = () => {
    if (
      appointmentDetail?.service?.title === 'procedure' ||
      appointmentDetail?.service?.title === 'followup' ||
      appointmentDetail?.service?.title === 'break' ||
      appointmentDetail?.service?.title == 'crp'
    ) {
      return (
        userData?.role !== 'ee' &&
        userData?.role !== 'ee_manager' &&
        (userData?.role === 'admin' ||
          userData?.role === 'super_admin' || // Admin can always edit/cancel
          appointmentDetail?.admin?.id === userData?.id || // The creator can edit/cancel
          (userData?.role === 'health_coach_lead' &&
            (appointmentDetail?.admin?.role === 'health_coach' ||
              appointmentDetail?.admin?.role === 'revenue_manager' ||
              appointmentDetail?.admin?.role === 'admin' ||
              appointmentDetail?.admin?.role === 'super_admin' ||
              appointmentDetail?.admin?.id === userData?.id)) ||
          ((userData?.role === 'health_coach' || userData?.role === 'revenue_manager') &&
            (appointmentDetail?.admin?.role === 'admin' || appointmentDetail?.admin?.role === 'super_admin')))
      );
    }

    if (appointmentDetail?.channel === 'Hum Pum') {
      return userData?.role === 'health_coach' || userData?.role === 'health_coach_lead';
    }

    switch (userData?.role) {
      case 'admin':
      case 'super_admin':
        return true; // Admin can always record/mark arrived

      case 'health_coach':
      case 'revenue_manager':
        return (
          appointmentDetail?.admin?.role === 'admin' ||
          appointmentDetail?.admin?.role === 'super_admin' ||
          appointmentDetail?.admin?.role === 'ee' ||
          appointmentDetail?.admin?.role === 'ee_manager' ||
          appointmentDetail?.admin?.id === userData?.id // Only if they created the appointment
        );

      case 'health_coach_lead':
        return (
          appointmentDetail?.admin?.role === 'health_coach' ||
          appointmentDetail?.admin?.role === 'revenue_manager' ||
          appointmentDetail?.admin?.role === 'ee' ||
          appointmentDetail?.admin?.role === 'ee_manager' ||
          appointmentDetail?.admin?.role === 'admin' ||
          appointmentDetail?.admin?.role === 'super_admin' ||
          appointmentDetail?.admin?.id === userData?.id // Their own appointments
        );
      case 'doctor':
        return (
          appointmentDetail?.admin?.role === 'health_coach' ||
          appointmentDetail?.admin?.role === 'revenue_manager' ||
          appointmentDetail?.admin?.role === 'ee' ||
          appointmentDetail?.admin?.role === 'ee_manager' ||
          appointmentDetail?.admin?.role === 'admin' ||
          appointmentDetail?.admin?.role === 'super_admin' ||
          appointmentDetail?.admin?.id === userData?.id // Their own appointments
        );
      case 'ee':
      case 'ee_manager':
        return false; // Explicitly restricted

      default:
        return false; // Default case restricts other roles
    }
  };

  const handlePushToOpd = (id) => {
    setIsLoading(true);
    const params = {
      patient_attendance_status: 'pushed_to_opd',
    };
    ApiClient.pushToOpd(params, id)
      .then((res) => {
        setIsLoading(false);
        dispatch(setIsPushedToOpd('yes'));
      })
      .catch((err) => {
        setIsLoading(false);
        dispatch(setIsPushedToOpd('no'));
      });
  };

  const schedulPopover = (
    <Popover visible className='schedulePopover'>
      <div className='popoverPart'>
        <div className='schedulePopover-head'>
          <div className='tileName'>
            <Link to={userData?.role !== 'ee' ? `/patient/${appointmentDetail?.user.id}/dashboard` : null}>
              {appointmentDetail?.user?.full_name} ({appointmentDetail?.user?.gender && appointmentDetail?.user?.gender[0].toUpperCase()},{' '}
              {appointmentDetail?.user?.date_of_birth && isBabyMd && ` ${ageInMonths} M`}
              {!isBabyMd && appointmentDetail?.user?.age})
            </Link>
          </div>
          <div className='d-flex justify-content-between align-items-center'>
            <div className='number'>{maskPhoneNumber(appointmentDetail?.user?.phone)}</div>
            {!isBabyMd && <div className='number'>{renderStatus()}</div>}
            {appointmentDetail?.consultation_status !== 'canceled' && isBabyMd && (
              <div className='number'>
                <Dropdown
                  className={`capitalize pointer patient-list-show-badge ${appointmentDetail.consultation_status}`}
                  disabled={userData?.read_only}
                  title={
                    <span className='capitalize'>
                      {titlizeString(appointmentDetail.consultation_status === 'show' ? 'Arrived' : appointmentDetail.consultation_status) || 'booked'}
                    </span>
                  }
                >
                  {(appointmentDetail?.patient_attendance_status === 'Transit'
                    ? status?.filter((statusItem) => statusItem?.id === 'canceled')
                    : status
                  )?.map((statusItem) => (
                    <Dropdown.Item
                      onClick={() => {
                        if (['show', 'no_show', 'arrived'].includes(statusItem.id)) {
                          setCreatedAppointment(appointmentDetail);
                          setOpen(true);
                          setStatusItem(statusItem);
                        } else if (statusItem.id === 'canceled') {
                          setCreatedAppointment(appointmentDetail);
                          setCancelModal(true);
                          setStatusItem(statusItem);
                        }
                      }}
                    >
                      {statusItem.title}
                    </Dropdown.Item>
                  ))}
                </Dropdown>
              </div>
            )}
          </div>
          {<p className='p-0 m-0'>Lead Source : {appointmentDetail?.user?.lead_source}</p>}
          {<p className='p-0 m-0'>Lead Type : {appointmentDetail?.user?.lead_type}</p>}
          {<p className='p-0 m-0'>Appointment Fees : {appointmentDetail?.appointment_fee || '0.00'}</p>}
          {appointmentDetail?.appointment_type === 'prepaid' && (
            <p className='p-0 m-0' style={{ color: '#0d6efd', fontWeight: 600 }}>
              Prepaid
            </p>
          )}
          {appointmentDetail?.channel?.toLowerCase() == 'web' ? (
            <p className='p-0 m-0' style={{ color: 'brown' }}>
              Website Appointment
            </p>
          ) : appointmentDetail?.channel ? (
            <p className='p-0 m-0' style={{ color: 'green' }}>
             <span style={{ color: 'black' }}>Channel : </span>{appointmentDetail.channel}
            </p>
          ) : null}
          <div>
            Created By:{' '}
            {['ronic_bot', 'briza_bot'].includes(appointmentDetail?.channel) ? appointmentDetail.channel : appointmentDetail?.admin?.full_name}
          </div>
        </div>

        <div className='schedulePopover-body'>
          <div className='d-flex justify-content-between schedule-part'>
            <div className='d-flex flex-column justify-content-start'>
              <div className='time'>
                {dateFormat(appointmentDetail?.consult_datetime)}, {timeFormat(appointmentDetail?.consult_datetime)} -{' '}
                {timeFormat(appointmentDetail?.consult_end_datetime)}
              </div>
              <span>With {appointmentDetail?.consultant?.full_name}</span>
              {appointmentDetail?.service?.title && (
                <div className='d-flex justify-content-start align-items-center mt-1'>
                  <div className='follow'>{appointmentDetail?.service?.title}</div>
                  {appointmentDetail?.complimentary_prc && (
                    <span style={{ color: '#28a745', fontWeight: 700, fontSize: '10px', marginLeft: '4px' }}>CP</span>
                  )}
                </div>
              )}
            </div>

            {/* Edit & Cancel Buttons */}
            {!userData?.read_only && appointmentDetail?.consultation_status !== 'canceled' &&
              appointmentDetail?.patient_attendance_status !== 'show' &&
              appointmentDetail?.patient_attendance_status !== 'no_show' && (
                <div className='d-flex justify-content-center align-items-center flex-column'>
                  {appointmentDetail?.patient_attendance_status !== 'Transit' &&
                    (appointmentDetail?.channel === 'Hum Pum' ? userData?.role === 'ee_manager' : canEditOrCancel()) && (
                    <div
                      onClick={() => {
                        if (appointmentDetail?.consultation_status === 'scheduled') {
                          handleAppointmentEdit(appointmentDetail?.id);
                        }
                      }}
                      className='d-flex justify-content-center align-items-center popover-btn'
                      style={{
                        cursor: appointmentDetail?.consultation_status === 'scheduled' ? 'pointer' : 'not-allowed',
                        backgroundColor: appointmentDetail?.consultation_status === 'scheduled' ? 'inherit' : '#B7B7B7',
                        opacity: appointmentDetail?.consultation_status === 'scheduled' ? 1 : 0.7,
                      }}
                    >
                      <span className='material-icons-outlined'>mode_edit_outline</span> Edit
                    </div>
                  )}

                  {(appointmentDetail?.channel === 'Hum Pum' ? userData?.role === 'ee_manager' : canEditOrCancel()) && (
                    <div
                      onClick={() => {
                        setCreatedAppointment(appointmentDetail);
                        setCancelModal(true);
                      }}
                      className='d-flex justify-content-center align-items-center popover-btn'
                    >
                      <span className='material-icons-outlined'>close</span> Cancel
                    </div>
                  )}
                </div>
              )}
          </div>

          {/* Join Button (unchanged) */}
          {appointmentDetail?.consult_type === 'virtual' && (
            <div className='d-flex justify-content-between schedule-part'>
              <div className='d-flex flex-column justify-content-start'>
                <span>
                  <img src={laptopLink} /> Online Consultation
                </span>
              </div>
              {((userData?.role !== 'ee' && userData?.role !== 'ee_manager') ||
                appointmentDetail?.admin?.id === userData?.id ||
                (userData?.role === 'ee_manager' && (appointmentDetail?.admin?.role === 'ee' || appointmentDetail?.admin?.role === 'ee_manager'))) &&
                appointmentDetail?.consultation_status !== 'canceled' &&
                appointmentDetail?.meeting_link && (
                  <a target='_blank' href={appointmentDetail?.meeting_link} className='d-flex flex-column align-items-center'>
                    <div className='d-flex justify-content-center align-items-center popover-btn disabled'>Join</div>
                  </a>
                )}
            </div>
          )}

          {/* Push To OPD Button */}
          {!userData?.read_only && appointmentDetail?.patient_attendance_status !== 'Transit' &&
            canRecordOrMarkArrived() && appointmentDetail?.service?.title && ['followup', 'consult'].includes(appointmentDetail?.service?.title) && (
            <div className='d-flex justify-content-center align-items-end flex-column mt-2'>
              <div
                onClick={() => appointmentDetail?.consultation_status === 'arrived' && handlePushToOpd(appointmentDetail?.id)}
                className='d-flex justify-content-center align-items-center popover-btn'
                style={{
                  backgroundColor: appointmentDetail?.consultation_status === 'arrived' ? '#243B86' : '#B7B7B7',
                  color: appointmentDetail?.consultation_status === 'arrived' ? 'white' : 'black',
                  cursor: appointmentDetail?.consultation_status === 'arrived' ? 'pointer' : 'not-allowed',
                  opacity: appointmentDetail?.consultation_status === 'arrived' ? 1 : 0.7,
                }}
              >
                Push To OPD
              </div>
              <div style={{ width: '100%', height: '1px', backgroundColor: '#E5E5E5', marginTop: '8px' }}></div>
            </div>
          )}

          {/* Record & Mark Arrived */}
          {!userData?.read_only && appointmentDetail?.patient_attendance_status !== 'Transit' &&
            canRecordOrMarkArrived() && (
            <div className='d-flex justify-content-center align-items-end flex-column mt-2'>
              <div
                className='d-flex justify-content-center align-items-end popover-btn active uniform-btn'
                onClick={() => {
                  setCreatedAppointment(appointmentDetail);
                  setOpen(true);
                  setStatusItem('');
                }}
              >
                Record
              </div>
              <div
                className={`d-flex justify-content-center align-items-end popover-btn uniform-btn ${
                  appointmentDetail?.consultation_status === 'arrived' || appointmentDetail?.patient_attendance_status === 'pushed_to_opd' ? 'disabled' : ''
                }`}
                onClick={() => {
                  if (!['arrived', 'show', 'no show'].includes(appointmentDetail?.consultation_status)) {
                    const confirmMarkArrived = window.confirm('Are you sure you want to mark this appointment as Arrived?');
                    if (confirmMarkArrived) {
                      handleRecordPayment(appointmentDetail?.id, { patient_attendance_status: 'arrived' });
                    }
                  }
                }}
                style={{
                  cursor:
                    ['arrived', 'show', 'no_show'].includes(appointmentDetail?.consultation_status) ||
                    appointmentDetail?.patient_attendance_status === 'pushed_to_opd'
                      ? 'not-allowed'
                      : 'pointer',
                  backgroundColor:
                    ['arrived', 'show', 'no_show'].includes(appointmentDetail?.consultation_status) ||
                    appointmentDetail?.patient_attendance_status === 'pushed_to_opd'
                      ? '#B7B7B7'
                      : 'inherit',
                  color: 'black',
                }}
              >
                Mark Arrived
              </div>
            </div>
          )}
          {!userData?.read_only && appointmentDetail?.patient_attendance_status !== 'Transit' && (
          <>
          <div className='d-flex justify-content-center align-items-end flex-column mt-2'>
            {appointmentDetail?.paf_id ? 
            <div className='d-flex justify-content-center align-items-end popover-btn active uniform-btn'
              onClick={() => {
                updatePAF(appointmentDetail?.user?.id,appointmentDetail?.id,appointmentDetail?.consultant?.id,appointmentDetail?.location?.id,appointmentDetail?.paf_id)
              }}
              >
                View Paf
            </div>
            :
            <div className='d-flex justify-content-center align-items-end popover-btn active uniform-btn'
              onClick={() => {
                newPAF(appointmentDetail?.user?.id,appointmentDetail?.id,appointmentDetail?.consultant?.id,appointmentDetail?.location?.id)
              }}
              >
                Initiate Paf
            </div>
            }
            
          </div>
          
          </>
          )}
        </div>
      </div>
    </Popover>
  );
  // const appointmentPopover = (
  //   <div style={{ height: 100, position: 'absolute' }}>
  //     <Popover visible>
  //       <div className='d-flex w-100 flex-column appointmentPopover schedulButton'>
  //         <div className='reusableBtnActive  reusableBtn text-nowrap  w-100 mb-2'>+ Add New Appointment</div>
  //         <div className='w-100 borderBtn mb-2 text-nowrap'>Mark As Unavailable</div>
  //       </div>
  //     </Popover>
  //   </div>
  // );

  // const actions = [
  //   { first: paymentLink, second: payment },
  //   { first: laptopLink, second: laptop },
  //   { first: user, second: userLink },
  // ];

  // const HoverImage = ({ first, second }) => {
  //   const [firstImage, setFirstImage] = useState(first);
  //   return (
  //     <div className='scheduleIcon'>
  //       <img src={firstImage} onMouseEnter={() => setFirstImage(second)} onMouseLeave={() => setFirstImage(first)} />

  //     </div>
  //   );
  // };

  return (
    <>
      <div className={`d-flex scheduleTile ${className}`} style={{ justifyContent: 'space-between', padding: '1px 3px' }}>
        <div style={{ width: '90%' }}>
          <Whisper placement='auto' trigger='hover' speaker={schedulPopover} controlId='control-id-hover-enterable' enterable>
            <span
              className='tileName'
              style={{
                color: appointmentDetail?.channel?.toLowerCase() === 'web'? '#000' : '#333',
                fontFamily: 'Inter',
                fontSize: '10px',
                fontStyle: 'normal',
                fontWeight: 500,
                lineHeight: '12px',
              }}
            >
              {appointmentDetail?.user?.full_name} ({appointmentDetail?.user?.gender && appointmentDetail?.user?.gender[0].toUpperCase()},{' '}
              {appointmentDetail?.user?.date_of_birth && isBabyMd && ` ${ageInMonths} M`}
              {!isBabyMd && appointmentDetail?.user?.age})
            </span>
          </Whisper>
          {height > 32 && <p className='p-0 m-0'>{maskPhoneNumber(appointmentDetail?.user?.phone)}</p>}
          {appointmentDetail?.appointment_type === 'prepaid' && (
            <p className='p-0 m-0' style={{ color: '#0d6efd', fontWeight: 600, fontSize: '9px' }}>
              Prepaid
            </p>
          )}
          {/* {<p className='p-0 m-0'>Lead Source : {appointmentDetail?.user?.lead_source}</p>} */}
          {height > 40 && <p className='p-0 m-0'>Created By : {appointmentDetail?.admin?.full_name}</p>}
          {height > 60 && (
            <div className='d-flex justify-content-between'>
              {renderStatus()}
              {/* <div className='d-flex'>
              {actions.map((action, index) => (
                <HoverImage key={index} first={action.first} second={action.second} />
              ))}
            </div> */}
              {/* <div className='d-flex'>
            <div className={`scheduleIcon me-1 ${appointmentDetail.amount!=='null'?'active':''}`}>
                {!appointmentDetail.amount!=='null'?<img src={payment}/>:
                <img src={paymentLink}/>}
              </div>
              <div className={`scheduleIcon me-1 ${appointmentDetail.consult_type=='physical'?'active':''}`}>
                {!appointmentDetail.consult_type=='virtual'?<img src={laptop}/>:
                <img src={laptopLink}/>}
              </div>
              <div className={`scheduleIcon ${appointmentDetail.consult_type=='virtual'?'active':''}`}>
                {!appointmentDetail.consult_type=='virtual'?<img src={user}/>:
                <img src={userLink}/>}
              </div>
            </div> */}
            </div>
          )}
        </div>
        {appointmentDetail?.complimentary_prc || appointmentDetail?.user?.lead_source != null ? (
          <div
            style={{
              backgroundColor: '#DCDFE3',
              height: '14px',
              width: appointmentDetail?.complimentary_prc ? '18px' : '14px',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              margin: '0 0',
              borderRadius: '50%',
            }}
          >
            <p
              style={{
                color: appointmentDetail?.complimentary_prc ? '#28a745' : '#243B86',
                fontFamily: 'Inter',
                fontSize: '6px',
                fontStyle: 'normal',
                fontWeight: appointmentDetail?.complimentary_prc ? 700 : 400,
                lineHeight: '0px',
              }}
            >
              {/* {appointmentDetail?.service?.title.toLowerCase() === 'procedure' && 'P'}
              {appointmentDetail?.service?.title.toLowerCase() === 'consult' && 'C'}
              {appointmentDetail?.service?.title.toLowerCase() === 'follow up' && 'F'}
              {appointmentDetail?.service?.title.toLowerCase() === 'break' && 'B'}
              {appointmentDetail?.service?.title.toLowerCase() === 'care plan' && 'CP'} */}
              {appointmentDetail?.complimentary_prc ? (
                'CP'
              ) : (
                <>
                  {appointmentDetail?.user?.lead_source?.toLowerCase() === 'dro' && 'D'}
                  {appointmentDetail?.user?.lead_source?.toLowerCase() === 'digital' && 'E'}
                  {appointmentDetail?.user?.lead_source?.toLowerCase() === 'organic' && 'O'}
                  {appointmentDetail?.user?.lead_source?.toLowerCase() === 'social' && 'S'}
                  {appointmentDetail?.user?.lead_source?.toLowerCase() === 'offline/brand marketing' && 'B'}
                  {appointmentDetail?.user?.lead_source?.toLowerCase() === 'ee lead' && 'EL'}
                  {appointmentDetail?.user?.lead_source?.toLowerCase() === 'camp' && 'C'}
                  {appointmentDetail?.user?.lead_source?.toLowerCase() === 'dro-lead' && 'DL'}
                  {appointmentDetail?.user?.lead_source?.toLowerCase() === 'others' && 'X'}
                  {appointmentDetail?.user?.lead_source?.toLowerCase() === 'doctor ref' && 'DR'}
                  {appointmentDetail?.user?.lead_source?.toLowerCase() === 'patient ref' && 'PR'}
                  {appointmentDetail?.user?.lead_source?.toLowerCase() === 'inbound call' && 'IC'}
                  {appointmentDetail?.user?.lead_source?.toLowerCase() === 'referred by doctor' && 'RD'}
                  {appointmentDetail?.user?.lead_source?.toLowerCase() === 'website' && 'W'}
                  {appointmentDetail?.user?.lead_source?.toLowerCase() === 'painacea clinic' && 'PA'}
                  {appointmentDetail?.user?.lead_source?.toLowerCase() === 'only physio services' && 'OPS'}
                  {appointmentDetail?.user?.lead_source?.toLowerCase() === 'Physio Partnerships' && 'PP'}
                </>
              )}
            </p>
          </div>
        ) : null}
      </div>
    </>
  );
}

export default DoctorSchedulTile;
